<template>
  <div class="c-target-wrap" :class="{'disabled-wrap': disabled}">
    <Spin v-if="!show" size="large" fix />
    <template v-else>
      <!-- 定向方式 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">定向包名称</span>
        </Col>
        <Col span="12">
          <input-len
            :value="targetName"
            :width="480"
            :max="20"
            placeholder="最大20个字符，1个中文等于2个字符"
            @change="$emit('on-name', $event)" />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">人群包</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.audienceMode" type="button" @on-change="changeRetarget">
            <Radio label="NONE">不限</Radio>
            <Radio label="AUDIENCE">定向排除人群</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-show="target.audienceMode === 'AUDIENCE'">
        <Col span="3" class="col-item">
          <span class="item-field">&nbsp;</span>
        </Col>
        <Col span="16">
          <audience
            ref="audience"
            :media="media"
            :dis-crowd="disCrowd"
            :data="target.retargeting_tags" />
        </col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">地域</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.district" type="button" @on-change="$emit('on-target-change', 'cityData')">
            <Radio label="NONE">不限</Radio>
            <Radio label="CITY">按省市</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="target.district === 'CITY'">
        <Col span="3">&nbsp;</Col>
        <Col span="14">
          <selecter
            v-model="mult_city"
            :data="target.data.cityData"
            :title="['省份', '城市']"
            @on-select="selectAll"
            @on-delete="delTag"
            @on-clear="clearTag" />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">性别</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.sex" type="button">
            <Radio label="0">不限</Radio>
            <Radio label="2">男</Radio>
            <Radio label="1">女</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">年龄</span>
        </Col>
        <Col span="18">
          <RadioGroup v-model="target.ageMode" type="button" @on-change="changeAgeMode">
            <Radio label="NONE">不限</Radio>
            <Radio label="RANGE">指定年龄段</Radio>
            <Radio label="CUSTOM">自定义年龄</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="target.ageMode === 'RANGE'">
        <Col span="3" class="col-item">
          <span class="item-field">&nbsp;</span>
        </Col>
        <Col span="18" class="col-flex">
          <CheckboxGroup v-model="target.age">
            <Checkbox label="1">18岁以下</Checkbox>
            <Checkbox label="2">18-24岁</Checkbox>
            <Checkbox label="3">25-34岁</Checkbox>
            <Checkbox label="4">35-44岁</Checkbox>
            <Checkbox label="5">45-54岁</Checkbox>
            <Checkbox label="6">54岁以上</Checkbox>
          </CheckboxGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="target.ageMode === 'CUSTOM'">
        <Col span="3" class="col-item">
          <span class="item-field">&nbsp;</span>
        </Col>
        <Col span="18">
          <range-age v-model="target.customAge" :offset="9" />
        </Col>
      </Row>
      <!-- 兴趣 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">兴趣</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.interestType" type="button" @on-change="$emit('on-target-change', 'interestData')">
            <Radio label="NONE">不限</Radio>
            <Radio label="CUSTOM" :disabled="useCrowd">按兴趣分类</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="target.interestType === 'CUSTOM'">
        <Col span="3" class="col-item">
          <span class="item-field">&nbsp;</span>
        </Col>
        <Col span="18">
          <selecter
            v-model="mult_interest"
            :data="target.data.interestData"
            :title="['按APP分类']"
            @on-select="selectAll"
            @on-delete="delTag"
            @on-clear="clearTag" />
        </Col>
      </Row>
      <!-- 意图词 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">商业意图</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.keywordsType" type="button" @on-change="changeKeyword">
            <Radio label="NONE">不限</Radio>
            <Radio label="ADD" :disabled="useCrowd">添加意图词</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <template v-if="target.keywordsType === 'ADD'">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="20">
            <keyword-interest
              v-model="target.keywords"
              :account="account"
              @on-select="appendMultword"
              @on-delete="deleteMultWord"
              @on-clear="$set(target, 'keywords', [])" />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="1" style="margin-right: 12px;">&nbsp;</Col>
          <Col span="3" class="col-item">
            <span class="item-field">用户行为</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="target.keywordsExtend" type="button">
              <Radio label="1">全网行为</Radio>
              <Radio label="2">历史搜索</Radio>
            </RadioGroup>
          </Col>
        </Row>
      </template>
      <!-- APP定向 -->
      <template v-if="isAndroid">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">APP定向</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="target.appType" type="button" @on-change="changeAppType">
              <Radio label="all">不限</Radio>
              <Radio label="category">按APP分类</Radio>
              <Radio label="custom">按APP名称</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="target.appType !== 'all'">
          <Col span="3" class="col-item">
            <span class="item-field">定向逻辑</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="target.appBehavior" type="button">
              <Radio :label="2">安装</Radio>
              <Radio :label="4">排除安装</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="target.appType === 'category'">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="20">
            <selecter
              v-model="mult_gategory"
              :data="target.data.gategoryData"
              :title="['按APP分类']"
              @on-select="selectAll"
              @on-delete="delTag"
              @on-clear="clearTag" />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="target.appType === 'custom'">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="18">
            <adder
              v-model="target.mult_app"
              :account="account"
              placeholder="请输入APP名称" />
          </Col>
        </Row>
      </template>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">操作系统</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.device" type="button">
            <Radio label="0" :disabled="!isLink">不限</Radio>
            <Radio label="2" :disabled="!isLink">Android</Radio>
            <Radio label="1" :disabled="!isLink">iOS</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="target.device === '1'">
        <Col span="3" class="col-item">
          <span class="item-field">iOS版本</span>
        </Col>
        <Col span="18">
          <Mixcheck v-model="target.iosVersion">
            <radio-item label="0">不限</radio-item>
            <check-item v-for="item in ios_version" :label="item.key" :key="item.key">
              {{item.label}}
            </check-item>
          </Mixcheck>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="target.device === '2'">
        <Col span="3" class="col-item">
          <span class="item-field">安卓版本</span>
        </Col>
        <Col span="18">
          <Mixcheck v-model="target.androidVersion">
            <radio-item label="0">不限</radio-item>
            <check-item v-for="item in android_version" :label="item.key" :key="item.key">
              {{item.label}}
            </check-item>
          </Mixcheck>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">网络</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.net" type="button">
            <Radio label="0">不限</Radio>
            <Radio label="1">WIFI</Radio>
            <Radio label="2">移动网络</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">人生阶段</span>
        </Col>
        <Col span="12">
          <Mixcheck v-model="target.lifeStage" type="button">
            <radio-item label="0">不限</radio-item>
            <check-item label="1">未婚</check-item>
            <check-item label="2">已婚</check-item>
            <check-item label="3">孕期</check-item>
            <check-item label="4">家有儿女</check-item>
          </Mixcheck>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">学历</span>
        </Col>
        <Col span="12">
          <Mixcheck v-model="target.education">
            <radio-item label="0">不限</radio-item>
            <check-item label="1">大学及以上</check-item>
            <check-item label="2">高中及以下</check-item>
            <check-item label="3">大专</check-item>
          </Mixcheck>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">智能扩量</span>
        </Col>
        <Col span="12" class="col-flex">
          <i-Switch v-model="target.autoExpansion" true-value="1" false-value="0" />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">过滤已转化用户</span>
        </Col>
        <Col span="17">
          <RadioGroup v-model="target.excludeTrans" type="button">
            <Radio label="0">不限</Radio>
            <Radio label="3">同单元</Radio>
            <Radio label="2">同计划</Radio>
            <Radio label="1">同账户</Radio>
          </RadioGroup>
        </Col>
      </Row>
    </template>
  </div>
</template>
<script>
import { isArray, findCheck, getNameOfData, clearTagOfData } from '@/common/js/utils'
import { android_version, ios_version } from '@/data/baidu/ad_target_data.js'

import InputLen from '@/components/input/input-len.vue'
import Selecter from '@/components/select/selecter.vue'
import Mixcheck from '@/components/mixcheck'
import CheckItem from '@/components/mixcheck/check-item'
import RadioItem from '@/components/mixcheck/radio-item'
import RangeAge from '@/components/range/baidu-age.vue'
import Adder from '@/views/create/baidu/components/add/adder'
import Audience from './retarget'
import KeywordInterest from '../keywordinterest/index'

export default {
  name: 'bdTarget',
  components: {
    InputLen,
    Selecter,
    Mixcheck,
    CheckItem,
    RadioItem,
    RangeAge,
    Audience,
    KeywordInterest,
    Adder
  },
  props: {
    target: {
      type: Object
    },
    targetName: {
      type: String
    },
    show: {
      type: Boolean
    },
    media: {
      type: [Number, String]
    },
    account: {
      type: [Number, String]
    },
    disabled: {
      type: Boolean
    },
    isAndroid: {
      type: Boolean
    },
    isUnion: {
      type: Boolean
    },
    landType: {
      type: String
    },
    isLink: {
      type: Boolean
    }
  },
  computed: {
    useCrowd() {
      return this.target.retargeting_tags.some((ret) => {
        return isArray(ret.includes) && ret.includes.length
      })
    },
    disCrowd() {
      const isUseWord = this.target.keywordsType === 'ADD'
      const isUseIntrest = this.target.interestType === 'CUSTOM'
      return isUseWord || isUseIntrest
    },
    mult_city() {
      return this.target.data && findCheck(this.target.data.cityData)
    },
    mult_interest() {
      return this.target.data && findCheck(this.target.data.interestData)
    },
    mult_gategory() {
      return this.target.data && findCheck(this.target.data.gategoryData)
    }
  },
  watch: {
    mult_city(nVal) {
      if (isArray(nVal)) {
        this.$set(
          this.target,
          'region',
          nVal.map((ret) => ret.id)
        )
      } else return []
    },
    mult_interest(nVal) {
      if (isArray(nVal)) {
        this.$set(
          this.target,
          'newInterests',
          nVal.map((ret) => ret.id)
        )
      } else return []
    },
    mult_gategory(nVal) {
      if (isArray(nVal)) {
        const gategory = nVal.map((ret) => {
          return {
            id: ret.id,
            name: ret.value
          }
        })
        this.$set(this.target, 'app', this.target.appType === 'category' ? gategory : [])
      } else return []
    }
  },
  data() {
    return {
      android_version: android_version,
      ios_version: ios_version
    }
  },
  methods: {
    appendMultword(vals) {
      this.target.keywords.push(...vals)
    },
    deleteMultWord(val) {
      if (!val) return
      const idx = this.target.keywords.indexOf(val)
      this.target.keywords.splice(idx, 1)
    },
    // 定向人群切换
    changeRetarget(val) {
      if (val === 'NONE') {
        this.target.retargeting_tags.forEach((ret) => {
          if (isArray(ret.audienceData)) {
            ret.audienceData.forEach((met) => {
              this.$set(met, 'select', '')
            })
          }
          ret.includes = []
          ret.excludes = []
        })
      }
    },
    changeAgeMode(val) {
      if (val === 'CUSTOM') {
        this.$set(this.target, 'age', '0')
        this.$set(this.target, 'customAge', [])
      } else {
        this.$set(this.target, 'age', val === 'RANGE' ? [] : '0')
        this.$set(this.target, 'customAge', '0')
      }
    },
    changeKeyword() {
      this.$set(this.target, 'keywordsExtend', '1')
      this.$set(this.target, 'keywords', [])
    },
    changeAppType(val) {
      if (val === 'all') {
        this.$set(this.target, 'appBehavior', undefined)
      } else if (!this.target.behavior) {
        this.$set(this.target, 'appBehavior', 2)
      }
      this.$set(this.target, 'mult_app', [])
      this.$emit('on-target-change', 'gategoryData')
    },
    // 全选
    selectAll({ list, check = true, current = '' }) {
      let data
      if (current) {
        const item = getNameOfData(list, current)
        data = item.children
      } else data = list
      // 递归选中
      const deepSelectAll = (items) => {
        items.some((ret) => {
          if (ret.children && ret.children.length) deepSelectAll(ret.children)
          this.$set(ret, 'check', check)
        })
      }
      deepSelectAll(data)
    },
    // 删除已选
    delTag({ list, name }) {
      const data = getNameOfData(list, name)
      if (data.children && data.children.length) {
        this.selectAll({ list, check: false, current: data.value })
      } else {
        this.$set(data, 'check', false)
      }
    },
    // 清空全部
    clearTag({ list }) {
      clearTagOfData(list, this)
    },
    selectCurrent() {
      this.$refs.audience && this.$refs.audience.selectCurrent()
    }
  }
}
</script>
<style lang="scss" scoped>
.col-flex {
  min-height: 32px;
  display: flex;
  align-items: center;
}
</style>
